<template>
  <ul class="p-the-header-navi-of-category-menu">
    <li v-for="({ label, url, children, ref }, key) in naviItem" :key="key">
      <CategoryNaviItemLink
        v-touch:tap
        tag="a"
        :params-object="parentItemObj(children)"
        :is-child-item="false"
        :href="url"
        @emit-child-item-object="emitChildItemObject"
      >
        <template #icon>
          <IconBase :width="24" :height="24" view-box="0 0 24 24">
            <IconTile />
          </IconBase>
        </template>

        <template #label>{{ label }}</template>
      </CategoryNaviItemLink>

      <!-- child -->
      <ul
        v-if="children"
        :ref="ref"
        class="p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--child"
      >
        <li
          v-for="({ name, sub_categories, icon }, childKey) in children"
          :key="childKey"
          class="p-the-header-navi-on-general__navi__item"
        >
          <CategoryNaviItemLink
            tag="button"
            :params-object="childItemObj(childKey, sub_categories, name)"
            @emit-child-item-object="emitChildItemObject"
          >
            <template #icon>
              <!-- <IconItemCategory :id="id ? id : ''" icon-color="#3c3c3c" :icon-size="24" /> -->
              <InlineSvg
                v-if="icon"
                :src="icon"
                width="20"
                height="20"
                :fill="iconColor"
                :aria-label="name"
              />
            </template>

            <template #label>{{ name }}</template>
          </CategoryNaviItemLink>

          <!-- grandchild -->
          <ul
            v-if="sub_categories"
            ref="grandchildNavi"
            class="p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--child p-the-header-navi-on-general__navi--grandchild"
          >
            <li
              v-for="({ name, id }, grandchildKey) in sub_categories"
              :key="grandchildKey"
              class="p-the-header-navi-on-general__navi__item"
            >
              <CategoryNaviItemLink
                v-touch:tap
                tag="a"
                :params-object="grandChildItemObj(grandchildKey)"
                :href="'/product-list/?product-category=' + id"
                @emit-child-item-object="emitChildItemObject"
              >
                <template #label>{{ name }}</template>
              </CategoryNaviItemLink>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script lang="ts">
import { gsap } from "gsap";
import IconBase from "@/common/components/atoms/IconBase.vue";

import IconTile from "@/common/components/icons/IconTile.vue";
// import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import InlineSvg from "vue-inline-svg";

import CategoryNaviItemLink from "@/common/components/organisms/header/general/CategoryNaviItemLink.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    // naviItem: { type: Array, required: true },
    iconColor: { type: String, required: true },
    pager: { type: Object, required: true },
    shown: { type: Boolean, required: true },
    dataOfPagerBeforeFormatting: { type: Object, required: true }
  },
  components: {
    IconBase,
    IconTile,
    // IconItemCategory,
    InlineSvg,
    CategoryNaviItemLink
  },
  watch: {
    internalPager() {
      this.startChildItemAnimation();
    },
    itemCategories() {
      this.naviItem[0].children = this.itemCategories;
    }
  }
})
export default class TheHeaderNaviOfCategoryMenu extends Vue {
  // naviItem!: any;
  iconColor!: string;
  pager!: any;
  shown!: boolean;
  dataOfPagerBeforeFormatting!: any;

  naviItem: Array<any> = [
    {
      label: "カテゴリー",
      url: false,
      children: [],
      ref: "categoryNavi"
    }
  ];

  get itemCategories() {
    return commons.itemCategories;
  }

  get internalShown() {
    return this.shown;
  }

  set internalShown(newValue) {
    if (newValue !== this.shown) {
      this.$emit("update:shown", newValue);
    }
  }

  get internalPager() {
    return this.pager;
  }

  set internalPager(newValue) {
    if (newValue !== this.pager) {
      this.$emit("update:pager", newValue);
    }
  }

  get internalDataOfPagerBeforeFormatting() {
    return this.dataOfPagerBeforeFormatting;
  }

  set internalDataOfPagerBeforeFormatting(newValue) {
    if (newValue !== this.dataOfPagerBeforeFormatting) {
      this.$emit("update:dataOfPagerBeforeFormatting", newValue);
    }
  }

  get parentItemObj() {
    return (children: any) => ({
      key: -1,
      children,
      refsName: "categoryNavi",
      pagerObj: {
        hierarchy: 1,
        text: "メインメニュー"
      }
    });
  }

  get childItemObj() {
    return (childKey: any, children: any, label: any) => ({
      key: childKey,
      children,
      refsName: "grandchildNavi",
      pagerObj: {
        hierarchy: 2,
        text: label
      }
    });
  }
  get grandChildItemObj() {
    return (grandchildKey: any) => ({
      key: grandchildKey,
      children: false,
      refsName: false,
      pagerObj: {
        text: false
      }
    });
  }

  // mounted() {
  //   this.creatNaviArray();
  // }

  // creatNaviArray() {
  //   const naviItem = this.naviItem;
  //   const itemCategories = this.itemCategories;
  //   let categoryArray = naviItem.map((value: any, index: any) => {
  //     if (value.children === "category") {
  //       return { value, index };
  //     }
  //     return {};
  //   });
  //   categoryArray = categoryArray.filter((v: any) => v);
  //   const resultCategoryArray = categoryArray[0].value;
  //   resultCategoryArray.children = itemCategories;
  // }

  emitChildItemObject(emitValue: any) {
    this.setChildItemObject(emitValue, true);
  }

  setChildItemObject(paramsObj: any, shown = true) {
    this.internalDataOfPagerBeforeFormatting = {
      paramsObj,
      shown
    };
  }

  initChildItemAnimation(shown: any) {
    const { refsName, key, oldRefsName, oldKey } = this.internalPager;
    const refs: any = this.$refs;
    const nextNavi = key < 0 ? refs[refsName] : refs[refsName][key];
    const width = 256 / 16;
    const speed = 0.12;
    let prevNavi: any;

    if (shown === false) {
      prevNavi = oldKey < 0 ? refs[oldRefsName] : refs[oldRefsName][oldKey];
    }

    this.$emit("animation-child-item", { speed, width, shown });

    const animationObj = {
      shown() {
        gsap.to(nextNavi, speed, {
          autoAlpha: 1,
          display: "block"
        });
      },

      hidden() {
        gsap.to(prevNavi, speed, {
          autoAlpha: 0,
          display: "none"
        });
      }
    };

    return animationObj;
  }

  startChildItemAnimation() {
    const { shown } = this;
    const animationObject = this.initChildItemAnimation(shown);

    if (shown) {
      animationObject.shown();
    } else {
      animationObject.hidden();
    }
  }
}
</script>
